<template>
    <div class="section">
        <div class="container-fluid">
            <div class="">
                <div class="container ">
                    <div class="columns" style="padding-top: 50px;">
                        <div class="column has-text-centered">
                            <h1 class="title">Statement</h1>
                        </div>
                    </div>
                    <div class="columns">

                        <div class="column mx-auto">
                            <div class="field select is-fullwidth select-dates">
                                <div class="control">
                                    <select v-model="dateInterval" @change="onChangeDate()">
                                        <option value="">Select Date Range</option>
                                        <option value="this_month">This Month</option>
                                        <option value="last_month">Previous Month</option>
                                        <option value="this_year">This Year</option>
                                        <option value="last_year">Previous Year</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="column mx-auto">
                            <div class="field">
                                <div class="control">
                                    <datetime
                                            input-class="input"
                                            v-model="startDate"
                                            :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                            type="date"
                                            value-zone="local"
                                            zone="local"
                                            placeholder="Select date from"
                                    ></datetime>
                                </div>
                                <span class="color-danger">{{ this.error_dates.start_date }}</span>
                            </div>
                        </div>
                        <div class="column mx-auto">
                            <div class="field">
                                <div class="control">
                                    <datetime
                                            input-class="input"
                                            v-model="endDate"
                                            :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                            type="date"
                                            value-zone="local"
                                            zone="local"
                                            placeholder="Select date to"
                                    ></datetime>
                                </div>
                                <span class="color-danger">{{ this.error_dates.end_date }}</span>
                            </div>
                        </div>
                        <div class="column mx-auto display-flex">
                            <button style="margin-right: 15px;" @click="showStatement"
                                    class="button is-block is-primary is-fullwidth" type="submit">View
                            </button>
                            <button style="margin-right: 15px;" @click="submitData" class="button is-block is-danger is-fullwidth"
                                    type="submit">Download PDF
                            </button>
                            <button @click="submitDataSheet" class="button is-block is-danger is-fullwidth"
                                    type="submit">Download EXCEL
                            </button>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column has-text-centered">
                            <div class="theme-table-container table-container center-column w-100">
                                <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                                    <thead>
                                    <tr>
                                        <th class="opening_balance"><span @click="setOrder('manager_id')" class="link">Opening Balance</span>
                                        </th>
                                        <th class="invoice_amount"><span @click="setOrder('manager_id')" class="link">Invoice Amount</span>
                                        </th>
                                        <th class="amount_paid"><span @click="setOrder('manager_id')" class="link">Amount Paid</span>
                                        </th>
                                        <th class="balance_due"><span @click="setOrder('manager_id')" class="link">Balance Due</span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td class="opening_balance">{{ currency }}{{ openingBalance | formatNumber }}</td>
                                        <td class="invoice_amount">{{ currency }}{{ invoicedAmount | formatNumber }}</td>
                                        <td class="amount_paid">{{ currency }}{{ amountPaid | formatNumber }}</td>
                                        <td class="balance_due">{{ currency }}{{ balanceDue | formatNumber }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="theme-table-container table-container center-column w-100">
                                <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                                    <thead>
                                    <tr>
                                        <th><span @click="setOrder('manager_id')" class="link">Date</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Transactions</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Details</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Amount</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Payments</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Balance</span></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="entry in statements">
                                        <td>{{ entry.date }}</td>
                                        <td>{{ entry.transactions }}</td>
                                        <td style="width: 300px;" v-html="entry.details"></td>
                                        <td>{{ currency }}{{ entry.amount > 0 ? entry.amount : '' | formatNumber }}</td>
                                        <td>{{ currency }}{{ entry.payments > 0 ? entry.payments : '' | formatNumber }}</td>
                                        <td>{{ currency }}{{ entry.balance > 0 ? entry.balance : '' | formatNumber }}</td>
                                    </tr>
                                    </tbody>
                                    <tfoot>
                                    <tr>
                                        <td colspan="5" align="right">Balance Due</td>
                                        <td>{{ currency+balanceDue }}</td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import apiUsers from './../../api/apiUsers'
    import {Datetime} from 'vue-datetime'
    import UnpaidClientInvoiceTableRow from "../Balance-Statement/UnpaidClientInvoiceTableRow";
    import UnpaidClientMultiInvoiceTableRow from "../Balance-Statement/UnpaidClientMultiInvoiceTableRow";
    import {ModelSelect} from "vue-search-select";
    import apiProformaInvoices from "../../api/apiProformaInvoices";
    import apiBankingTransactions from "../../api/apiBankingTransactions";

    export default {
        components: {
            UnpaidClientInvoiceTableRow,
            UnpaidClientMultiInvoiceTableRow,
            ModelSelect,
            Datetime
        },
        data() {
            return {
                error_dates: {
                    start_date: '',
                    end_date: '',
                },
                statements: [],
                balanceDue: 0,
                openingBalance: 0,
                invoicedAmount: 0,
                amountPaid: 0,
                currency: '',
                start_date: new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1).toISOString(),
                end_date: new Date().toISOString(),
                dateInterval: 'this_month'
            }
        },
        computed: {
            startDate: {
                get() {
                    return this.start_date;
                },
                set(value) {
                    this.dateInterval = ""
                    this.start_date = value
                }
            },
            endDate: {
                get() {
                    return this.end_date;
                },
                set(value) {
                    this.dateInterval = ""
                    this.end_date = value
                }
            }
        },
        methods: {
            onChangeDate() {
                this.start_date = '';
                this.end_date = '';
            },
            submitData() {
                this.error_dates.start_date = '';
                this.error_dates.end_date = '';
                if (this.start_date == "" && this.dateInterval == "") {
                    alert("start date is blank")
                    this.error_dates.start_date = "Start date is required"
                    return false;
                }
                if (this.end_date == "" && this.dateInterval == "") {
                    alert('end date is blank')
                    this.error_dates.end_date = "End date is required"
                    return false;
                }
                let set_dates = {start_date: this.start_date, end_date: this.end_date, dateInterval: this.dateInterval}
                apiBankingTransactions
                    .downloadStatement(set_dates)
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]))
                        const link = document.createElement('a')
                        link.href = url
                        //const name = Number(id).toString().padStart(6, 0)
                        link.setAttribute('download', 'Statement' + '.pdf')
                        document.body.appendChild(link)
                        link.click()
                    })

                /*apiUsers
                    .requestAllUsers(this.set_dates)
                    .then((response) => {
                        console.log(response)
                        console.log(this.set_dates)
                        this.setSelectOptions(response.data)
                    })
                    .catch((error) => {
                        console.log(error)
                    })*/
                //e.preventDefault();
            },
            submitDataSheet() {
                this.error_dates.start_date = '';
                this.error_dates.end_date = '';
                if (this.start_date == "" && this.dateInterval == "") {
                    alert("start date is blank")
                    this.error_dates.start_date = "Start date is required"
                    return false;
                }
                if (this.end_date == "" && this.dateInterval == "") {
                    alert('end date is blank')
                    this.error_dates.end_date = "End date is required"
                    return false;
                }
                let set_dates = {start_date: this.start_date, end_date: this.end_date, dateInterval: this.dateInterval}
                apiBankingTransactions
                    .downloadStatementSheet(set_dates)
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]), {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', 'Statement.xlsx')
                        document.body.appendChild(link)
                        link.click()
                        commit('setDownloadStatus', false)
                        resolve()
                    })
                    .catch(error => {
                        commit('setDownloadStatus', false)
                        console.log(error)
                        //commit('setErrors', JSON.parse(error.response.data))
                        reject()
                    })

                /*apiUsers
                    .requestAllUsers(this.set_dates)
                    .then((response) => {
                        console.log(response)
                        console.log(this.set_dates)
                        this.setSelectOptions(response.data)
                    })
                    .catch((error) => {
                        console.log(error)
                    })*/
                //e.preventDefault();
            },
            showStatement() {
                let set_dates = {start_date: this.start_date, end_date: this.end_date, dateInterval: this.dateInterval}
                apiBankingTransactions
                    .showStatement(set_dates)
                    .then((response) => {
                        this.currency = response.data.currency
                        this.statements = response.data.statement_lines
                        this.balanceDue = response.data.balance_due
                        this.openingBalance = response.data.opening_balance
                        this.amountPaid = response.data.amount_paid
                        /* const url = window.URL.createObjectURL(response.data)
                         this.statementLink = url;*/
                    })
            }
        },
        mounted() {
            this.showStatement()
        }
    }
</script>

<style scoped>
    .statement-iframe {
        width: 100%;
        height: 600px;
        background: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/Statement/Statement.vue